// extracted by mini-css-extract-plugin
export default {"infoBox":"DistributionHighlights_infoBox__6EM+W"};